import type { TonWalletSessionEndReason } from './session/events'
import type { User, WalletCallbacks } from './types'

export interface ReadonlyValue<T> {
  readonly value: T
}

export interface TonTransactionMessage {
  address: string
  amount: string
  payload?: string
}

export interface TonTransactionRequest {
  validUntil: number
  messages: TonTransactionMessage[]
}

export interface TonWalletController {
  selectors: {
    isConnected: ReadonlyValue<boolean>
    isAuthenticated: ReadonlyValue<boolean>
    hasActiveSession: ReadonlyValue<boolean>
    isRestoreSettled: ReadonlyValue<boolean>
    isBackendAuthRestoring: ReadonlyValue<boolean>
    isConnecting: ReadonlyValue<boolean>
    address: ReadonlyValue<string>
    shortAddress: ReadonlyValue<string>
    user: ReadonlyValue<User | null>
    hasRestorableSession: ReadonlyValue<boolean>
  }
  commands: {
    setCallbacks: (callbacks: WalletCallbacks) => void
    setUser: (user: User | null) => void
    connect: () => Promise<boolean>
    recheckBackendSession: () => Promise<boolean>
    reconnectForFreshProof: () => Promise<boolean>
    disconnect: (reason?: TonWalletSessionEndReason) => void
    openExplorer: (txHash: string) => void
    openAddress: (address: string) => void
    sendTransaction: (request: TonTransactionRequest) => Promise<unknown>
    restoreSession: () => Promise<boolean>
    hasRestorableSession: () => boolean
  }
}

let installedController: TonWalletController | null = null

export const installTonWalletController = (controller: TonWalletController): void => {
  installedController = controller
}

export const getTonWalletController = (): TonWalletController => {
  if (!installedController) throw new Error('ton_wallet_controller_not_installed')
  return installedController
}
